export const Api_Url = `https://unizdemoapi.scizers.com`
export const Api_Url2 = `https://unizdemoapi2.scizers.com`
export const Reeudo_Url = `https://unizdemoapi2.scizers.com`
export const Unizhome_Url = `https://unizdemoapi2.scizers.com`
export const XTravel_Url = `http://demoapi.xtravelworld.com`
